import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import theme from "../theme";

const SwitchWrapper = styled(Box)(() => ({
  width: "344px",
  height: "40px",
  backgroundColor: "#F7F7F7",
  borderRadius: "8px",
  padding: "4px",
  display: "flex",
  position: "relative",
  justifyContent: "space-between",
  alignItems: "center",
  boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
  [theme.breakpoints.down("sm")]: {
    width: "270px",
  },
  [theme.breakpoints.up("sm")]: {
    width: "300px",
  },
  [theme.breakpoints.up("md")]: {
    width: "344px",
  },
}));

const SwitchButton = styled(Box)(() => ({
  flex: 1,
  height: "100%",
  zIndex: 1,
  borderRadius: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
}));

const Slider = styled("div")(() => ({
  position: "absolute",
  top: 4,
  bottom: 4,
  left: 4,
  width: "calc(50% - 4px)",
  borderRadius: "8px",
  backgroundColor: "#fff",
  transition: "all 0.3s ease",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
}));

const PayoutSwitch = ({ selectedTab, setSelectedTab }: any) => {
  return (
    <SwitchWrapper>
      {/* Background slider */}
      <Slider
        style={{
          left: selectedTab === "cash" ? 4 : "calc(50% + 4px)",
        }}
      />

      {/* Labels */}
      <SwitchButton onClick={() => setSelectedTab("cash")}>
        <Typography
          variant="body2"
          sx={{
            color: selectedTab === "cash" ? "#EC6E00" : "text.primary",
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          Cash Payout
        </Typography>
      </SwitchButton>
      <SwitchButton onClick={() => setSelectedTab("service")}>
        <Typography
          variant="body2"
          sx={{
            color: selectedTab === "service" ? "#EC6E00" : "text.primary",
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          Service Payout
        </Typography>
      </SwitchButton>
    </SwitchWrapper>
  );
};

export default PayoutSwitch;
